import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles(() => {
  return createStyles({
    green: {
      color: colors.green
    },
    blue: {
      color: colors.blue
    },
    gray: {
      color: colors.defaultGrey
    },
    compactContainer: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '100%',
      minWidth: 0,
      width: '100%',
      overflow: 'hidden'
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      flex: 1,
      marginLeft: '8px',
      overflow: 'hidden'
    },
    unitName: {
      fontWeight: 500,
      lineHeight: 1.3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    metadata: {
      lineHeight: 1.2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  });
});
